import React from "react";

import SvgIcon from "@material-ui/core/SvgIcon";

interface IProps {
  className?: string;
}

const LastRaceIcon = (props: IProps) => {
  const { className } = props;

  return (
    <SvgIcon className={className} viewBox="10 10 22 22">
      <g xmlns="http://www.w3.org/2000/svg" fill="currentColor">
        <path d="M10,22.1l3.6,3.6c0.1,0.1,0.3,0,0.3-0.1v-2.1H32c0.1,0,0.2-0.1,0.2-0.2v-2.7c0-0.1-0.1-0.2-0.2-0.2H13.9v-2.1   c0-0.1-0.2-0.2-0.3-0.1L10,21.9C10,22,10,22,10,22.1z" />
        <rect x="24.3" y="29.5" width="5.7" height="2.4" />
        <path d="M21.1,29.5h-8.6C8.4,29.5,5,26.1,5,22c0-4.1,3.3-7.5,7.5-7.5h0.2v-2.4h-0.2c-5.4,0-9.9,4.4-9.9,9.9s4.4,9.9,9.9,9.9h8.6   V29.5z" />
        <rect x="16" y="12.1" width="5.1" height="2.4" />
        <path d="M31.5,12.1h-7.2v2.4h7.2c4.1,0,7.5,3.3,7.5,7.5c0,3.5-2.5,6.5-5.8,7.3v2.5c4.6-0.8,8.2-4.8,8.2-9.7   C41.4,16.6,37,12.1,31.5,12.1z" />
      </g>
    </SvgIcon>
  );
};

export default LastRaceIcon;
